import App from "./App";
import "./styles/main.scss";
import "../../shared/gb-simba.css";
import { createRoot } from "@wordpress/element";

const Init = () => {
  const root = createRoot(document.getElementById("elgordo"));
  root && root.render(<App />);
};

Init();
